function isDefined(element) {
	return ( typeof element !== typeof undefined );
}

function setCookie(cname, cvalue, exdays) {
	const d = new Date();

	d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));

	let expires = "expires=" + d.toUTCString();

	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
	let name = cname + "=";
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(';');

	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];

		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}

		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}

	return null;
}

/*
 * Stops execution for "ms" millisenconds
 * !! ATTENTION: use .then(() => <your_code_here>) for subsequent instructions
 */
function sleep(ms) {
	return new Promise(resolve => setTimeout(resolve, ms));
}

function initDeferAnimation() {
	let deferredBlocks = document.querySelectorAll('[data-defer]');
	deferredBlocks = [...document.querySelectorAll('.wp-block-columns:not(article > .wp-block-columns:first-of-type)')];

	// Alle alte risoluzioni, se i contenuti della pagina sono pochi, il primo blocco colonne non risulta visibile
	// Pertanto lo escludiamo dal selettore in modo che non gli venga applicato il data-defer

	deferredBlocks.forEach((block) => {
		const blockInner = block.children;

		gsap.set(blockInner, { y: 30, scale: 0.99, autoAlpha: 0 })
	})

	const deferInstances = ScrollTrigger.batch(deferredBlocks, {
		start: 'top 85%',
		end: 'bottom 15%',
		onToggle: (blocks) => {
			const children = [];

			blocks.forEach((block) => {
				children.push(...block.children);
			});

			gsap.to(children, {
				y: 0,
				scale: 1,
				autoAlpha: 1,
				duration: 0.48,
				stagger: 0.12,
			});

		}
	});
}

function openContactPanel() {
	
	// Lock page scroll
	const scrollY = window.scrollY;
	document.body.style.position = 'fixed';
	document.body.style.top = "-" + scrollY + "px";

	document.body.classList.add('--show-contact');
	document.querySelector('header').classList.add('text-white');
}

function closeContactPanel() {
	document.body.classList.remove('--show-contact');
	document.querySelector('header').classList.remove('text-white');

	// Unkock page scroll
	const scrollY = document.body.style.top;
	document.body.style.position = '';
	document.body.style.top = '';
	window.scrollTo(0, parseInt(scrollY || '0') * -1);
}




/*
 * Main entry point for JS handlers on different pages
 */
document.addEventListener('DOMContentLoaded', e => {

	if (document.getElementById('header-contact') != null) {
		// Open contact panel
		document.getElementById('header-contact').addEventListener('click', (e) => {

			if (!document.body.classList.contains('--show-contact')) {
				openContactPanel();
			}
			else {
				closeContactPanel();
			}
			
		});

		// Close contact panel
		document.body.addEventListener('click', (e) => {
			if ((!e.target.closest('#contact-panel')) && (!e.target.closest('#header-contact'))) {
				if (document.body.classList.contains('--show-contact')) {
					closeContactPanel();
				}
			}
		});
	}

	// GSAP plugins loading
	gsap.registerPlugin(ScrollTrigger);
	// Fade in content animation
	initDeferAnimation();
});
